import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.hk'
import yieldLadder from './yieldLadder.hk'

export default createLendingBundle({ whitepaper, yieldLadder })
